import { marketingAnalyticsSettingsSchema } from "@redotech/redo-marketing-common/marketing-analytics-settings";

export const updateMarketingAnalyticsSettings = {
  name: "updateMarketingAnalyticsSettings" as const,
  input: marketingAnalyticsSettingsSchema,
  output: marketingAnalyticsSettingsSchema,
};
